import React from 'react';
import { Link } from 'react-router-dom';
import { sessionManager } from '../../config/sessionManager';
import { usePlayerSheetOptional } from './PlayerSheetContext';
import { PlayerSheetVariant } from './playerSheetTypes';

interface PlayerNameButtonProps {
  children: React.ReactNode;
  playerSeasonId?: string | null;
  playerId?: string | null;
  seasonId?: string | null;
  variant?: PlayerSheetVariant;
  className?: string;
}

const PlayerNameButton: React.FC<PlayerNameButtonProps> = ({
  children,
  playerSeasonId,
  playerId,
  seasonId,
  variant = 'season',
  className = 'text-[#05396b] font-semibold hover:underline',
}) => {
  const sheet = usePlayerSheetOptional();
  const canOpenSeason = !!playerSeasonId && !!seasonId;
  const canOpenCareer = variant === 'career' && !!playerId;

  if (sheet && (canOpenSeason || canOpenCareer)) {
    return (
      <button
        type="button"
        className={className}
        onClick={(e) => {
          e.stopPropagation();
          sheet.openSheet({
            variant,
            playerSeasonId: playerSeasonId || undefined,
            playerId: playerId || undefined,
            seasonId: seasonId || undefined,
            clientId: sessionManager.getClientId() || undefined,
          });
        }}
      >
        {children}
      </button>
    );
  }

  const fallback =
    variant === 'career' && playerId
      ? `/players/${playerId}/stats`
      : seasonId && playerSeasonId
        ? `/seasons/${seasonId}/players/${playerSeasonId}`
        : null;

  if (fallback) {
    return (
      <Link to={fallback} className={className} onClick={(e) => e.stopPropagation()}>
        {children}
      </Link>
    );
  }

  return <>{children}</>;
};

export default PlayerNameButton;
